// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"f1fd7a6d","657":"784d003e","665":"784d003e","696":"a0244f78","886":"784d003e"}[chunkId] + ".chunk.css";
};